import { render } from "./FormularioCategoriaProduto.vue?vue&type=template&id=0190f9e3&scoped=true"
import script from "./FormularioCategoriaProduto.vue?vue&type=script&lang=js"
export * from "./FormularioCategoriaProduto.vue?vue&type=script&lang=js"

import "./FormularioCategoriaProduto.vue?vue&type=style&index=0&id=0190f9e3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0190f9e3"]])

export default __exports__